import { Handwriting } from './styles'

export default Handwriting
